exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:767px){.bg-purple-mobile-switch-language[data-v-02ae31e4]{background-color:#6c2bd9;background-color:rgba(108,43,217,var(--bg-opacity))}}", ""]);

// exports
